import styled from "styled-components";
import {
  REGISTRATION_FOCUS_RING,
  REGISTRATION_FONT_BODY,
  REGISTRATION_FOREST,
  REGISTRATION_HOVER_FILL,
} from "../../../RegistrationLayout/registrationTheme";
import {
  ModalOverlay as BaseModalOverlay,
  ModalPanel as BaseModalPanel,
  ModalHeader as BaseModalHeader,
  ModalTitle,
  ModalCloseBtn as BaseModalCloseBtn,
  ModalBody as BaseModalBody,
  GotItBtn as BaseGotItBtn,
} from "../../CardOnFile/CancellationPolicyModal/CancellationPolicyModal.style";

export { ModalTitle };

export const ModalCloseBtn = styled(BaseModalCloseBtn)`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin: -8px -8px 0 0;
  padding: 0;
  font-size: 32px;
  line-height: 1;
`;

export const ModalOverlay = styled(BaseModalOverlay)`
  align-items: flex-start;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: max(16px, env(safe-area-inset-top, 0px)) 16px
    max(16px, env(safe-area-inset-bottom, 0px));
`;

export const ModalPanel = styled(BaseModalPanel)`
  margin: auto;
  height: auto;
  min-height: 0;
  max-height: min(90dvh, 720px);
  overflow: hidden;
`;

export const ModalHeader = styled(BaseModalHeader)`
  flex-shrink: 0;
  align-items: flex-start;
  gap: 12px;
  padding: 20px 24px 16px;
`;

export const ModalHeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 0;
`;

export const ModalBody = styled(BaseModalBody)`
  flex: 0 1 auto;
  min-height: 0;
  overflow: hidden;
  padding: 16px 24px 20px;
`;

export const GotItBtn = styled(BaseGotItBtn)`
  margin-top: 0;
  padding: 12px 16px;
  width: auto;
  flex: 1 1 0;
  min-width: 0;
  white-space: normal;
  line-height: 1.25;
  text-align: center;
`;

export const ConfirmScrollArea = styled.div`
  flex: 0 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  margin: 0 -4px 12px;
  padding: 0 4px 4px;
`;

export const ConfirmIntro = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: #5a6b80;
  font-family: ${REGISTRATION_FONT_BODY};
  font-weight: 400;
`;

export const DetailList = styled.dl`
  margin: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 16px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const DetailRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const DetailLabel = styled.dt`
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: ${REGISTRATION_FOREST};
  font-family: ${REGISTRATION_FONT_BODY};
`;

export const DetailValue = styled.dd`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #2d3f52;
  font-family: ${REGISTRATION_FONT_BODY};
  word-break: break-word;
`;

export const ConfirmActions = styled.div`
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  align-items: stretch;
  gap: 10px;
  margin-top: 12px;
  padding-bottom: 0;

  ${GotItBtn} {
    margin-top: 0;
  }
`;

export const CancelBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 0;
  min-width: 0;
  width: auto;
  padding: 12px 16px;
  border-radius: 999px;
  border: 1.5px solid rgba(30, 42, 53, 0.2);
  background: #ffffff;
  color: #5a6b80;
  font-family: ${REGISTRATION_FONT_BODY};
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  text-align: center;
  white-space: normal;
  line-height: 1.25;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: ${REGISTRATION_HOVER_FILL};
    border-color: ${REGISTRATION_FOCUS_RING};
  }

  &:focus-visible {
    outline: 3px solid ${REGISTRATION_FOCUS_RING};
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;
